import React from 'react';
import { 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableRow, 
  Box 
} from '@material-ui/core';
import { formattedCurrency } from '../../../utils/utils';

const commonStyles = {
  container: {
    backgroundColor: '#fff',
    color: '#000',
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  header: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '10pt',
  },
  cell: {
    padding: '4px 0',
  },
  bold: {
    fontWeight: 'bold',
  },
  borderBottom: {
    borderBottom: '1px solid #000',
  },
  dashedBottom: {
    borderBottom: '1px dashed #ccc',
  }
};

export const ThermalTemplate = ({ data, credencials, options = {} }) => {
  if (!data) return null;

  const isSession = !!data.sale_metadata;
  const products = isSession
    ? (data.sale_metadata.products || [])
    : (data.details?.products || (Array.isArray(data.products) ? data.products.filter(p => p.type !== 'service') : []));
  const services = isSession
    ? (data.sale_metadata.services || [])
    : (data.details?.services || (Array.isArray(data.products) ? data.products.filter(p => p.type === 'service') : (Array.isArray(data.services) ? data.services : [])));
  const total = Number(isSession ? data.sale_metadata.total : (data.value !== undefined ? data.value : data.total)) || 0;
  const discount = Number(isSession ? data.sale_metadata.discount : (data.discount !== undefined ? data.discount : data.details?.discount)) || 0;
  const increase = Number(isSession ? data.sale_metadata.increase : (data.increase !== undefined ? data.increase : data.details?.increase)) || 0;
  const displayId = isSession ? data.identifier : (data.saleId || data.id);
  const displayCustomer = isSession
    ? data.responsible
    : (data.customerData?.name
        ? `${data.customerData.name} ${data.customerData.lastName || ''}`.trim()
        : options.customer?.name
          ? `${options.customer.name} ${options.customer.lastName || ''}`.trim()
          : (typeof data.customer === 'object' && data.customer?.name
              ? `${data.customer.name} ${data.customer.lastName || ''}`.trim()
              : (typeof data.customerFormatted === 'string' ? data.customerFormatted : (typeof data.customer === 'string' && isNaN(data.customer) ? data.customer : 'Avulso'))));
  const displayResponsible = (typeof data.responsible === 'string' && isNaN(data.responsible) ? data.responsible : null)
    || data.userName
    || data.sellerName
    || (credencials?.name ? `${credencials.name} ${credencials.lastName || ''}`.trim() : null)
    || (typeof data.userId === 'string' && isNaN(data.userId) ? data.userId : null)
    || '---';

  const numberOfPeople = options.numberOfPeople || 1;
  const valuePerPerson = total / numberOfPeople;

  return (
    <Box style={{ backgroundColor: '#fff', color: '#000', width: '80mm', margin: '0 auto', fontFamily: 'monospace', padding: '5mm' }}>
      <Typography variant="h6" align="center" style={{ fontWeight: 'bold', fontSize: '14pt' }}>
        {credencials.companyData?.pseudonimo}
      </Typography>
      
      {credencials.companyData?.showCNPJ && credencials.companyData?.cnpj && (
        <Typography variant="caption" display="block" align="center">CNPJ: {credencials.companyData.cnpj}</Typography>
      )}

      <Box my={1} py={0.5} borderTop="1px solid #000" borderBottom="1px solid #000">
        <Typography variant="body1" align="center" style={{ fontWeight: 'bold' }}>
          {isSession ? 'CONFERÊNCIA DE CONTA' : 'CUPOM NÃO FISCAL'}
        </Typography>
      </Box>

      <Typography variant="body2" align="center" style={{ marginBottom: '5mm' }}>
        {isSession ? 'COMANDA' : 'PEDIDO'} # {displayId}
      </Typography>

      <Table size="small">
        <TableBody>
            <TableRow>
            <TableCell style={{ border: 'none', padding: '2pt 0' }}>{isSession ? 'Responsável:' : 'Cliente:'}</TableCell>
              <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{displayCustomer}</TableCell>
            </TableRow>
          {!isSession && (
            <TableRow>
              <TableCell style={{ border: 'none', padding: '2pt 0' }}>Vendedor:</TableCell>
              <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{displayResponsible}</TableCell>
            </TableRow>
          )}
          {options.promotion && (
            <TableRow>
              <TableCell style={{ border: 'none', padding: '2pt 0' }}>Promoção:</TableCell>
              <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{options.promotion.name}</TableCell>
            </TableRow>
          )}
          {discount > 0 && (
            <TableRow>
              <TableCell style={{ border: 'none', padding: '2pt 0' }}>Desconto:</TableCell>
              <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{formattedCurrency(discount)}</TableCell>
            </TableRow>
          )}
          {increase > 0 && (
            <TableRow>
              <TableCell style={{ border: 'none', padding: '2pt 0' }}>Acréscimo:</TableCell>
              <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{formattedCurrency(increase)}</TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell style={{ border: 'none', padding: '2pt 0', fontWeight: 'bold' }}>TOTAL:</TableCell>
            <TableCell align="right" style={{ border: 'none', padding: '2pt 0', fontWeight: 'bold' }}>{formattedCurrency(total)}</TableCell>
          </TableRow>
          
          {numberOfPeople > 1 && (
            <TableRow>
              <TableCell style={{ border: 'none', borderTop: '1px solid #000', padding: '4pt 0', fontWeight: 'bold' }}>POR PESSOA ({numberOfPeople}):</TableCell>
              <TableCell align="right" style={{ border: 'none', borderTop: '1px solid #000', padding: '4pt 0', fontWeight: 'bold' }}>{formattedCurrency(valuePerPerson)}</TableCell>
            </TableRow>
          )}

          {!isSession && (
            <>
              <TableRow>
                <TableCell style={{ border: 'none', padding: '2pt 0' }}>Pago:</TableCell>
                <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>{formattedCurrency(data.amountPaid)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: 'none', padding: '2pt 0', verticalAlign: 'top' }}>Parcelas:</TableCell>
                <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>
                  {data.plots && Object.entries(data.plots).map(([key, val]) => {
                    const isPaid = typeof val === 'string' && val.toLowerCase().includes('paga');
                    const amount = isPaid ? Number(val.split(' -')[0]) : Number(val);
                    return (
                      <div key={key}>{key}ª: {formattedCurrency(amount)}{isPaid ? ' (P)' : ''}</div>
                    );
                  })}
                </TableCell>
              </TableRow>
            </>
          )}
          
          <TableRow>
            <TableCell colSpan={2} style={{ border: 'none', borderTop: '1px dashed #ccc', fontWeight: 'bold', paddingTop: '10px' }}>
              ITENS CONSUMIDOS
            </TableCell>
          </TableRow>
          {[...products, ...services].map((p, i) => {
            const itemSubtotal = p.subtotal !== undefined ? Number(p.subtotal) : (Number(p.price || p.value || 0) * Number(p.amount || 1));
            const itemDiscount = Number(p.discount) || 0;
            const itemTotal = p.total !== undefined ? Number(p.total) : (itemSubtotal - itemDiscount);

            return (
              <TableRow key={i}>
                <TableCell style={{ border: 'none', padding: '2pt 0' }}>
                  <div>{p.amount}x {p.item || p.name}</div>
                  {itemDiscount > 0 && (
                    <div style={{ fontSize: '7pt', color: '#555' }}>
                      (Desc: -{formattedCurrency(itemDiscount)})
                    </div>
                  )}
                </TableCell>
                <TableCell align="right" style={{ border: 'none', padding: '2pt 0' }}>
                  {itemDiscount > 0 ? (
                    <div>
                      <span style={{ textDecoration: 'line-through', fontSize: '7pt', color: '#777', marginRight: '3px' }}>
                        {formattedCurrency(itemSubtotal)}
                      </span>
                      <span>{formattedCurrency(itemTotal)}</span>
                    </div>
                  ) : (
                    formattedCurrency(itemSubtotal)
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      
      <Box mt={2} textAlign="center">
        <Typography variant="caption" display="block">
          {isSession ? '*** DOCUMENTO PARA CONFERÊNCIA ***' : '*** OBRIGADO PELA PREFERÊNCIA ***'}
        </Typography>
        <Typography variant="caption" display="block">{new Date().toLocaleString()}</Typography>
        <Typography variant="body2" style={{ marginTop: '10px' }}>✂ - - - - - -</Typography>
      </Box>
    </Box>
  );
};

export const A4Template = ({ data, credencials, options = {} }) => {
  if (!data) return null;

  const isSession = !!data.sale_metadata;
  const products = isSession
    ? (data.sale_metadata.products || [])
    : (data.details?.products || (Array.isArray(data.products) ? data.products.filter(p => p.type !== 'service') : []));
  const services = isSession
    ? (data.sale_metadata.services || [])
    : (data.details?.services || (Array.isArray(data.products) ? data.products.filter(p => p.type === 'service') : (Array.isArray(data.services) ? data.services : [])));
  const total = Number(isSession ? data.sale_metadata.total : (data.value !== undefined ? data.value : data.total)) || 0;
  const discount = Number(isSession ? data.sale_metadata.discount : (data.discount !== undefined ? data.discount : data.details?.discount)) || 0;
  const increase = Number(isSession ? data.sale_metadata.increase : (data.increase !== undefined ? data.increase : data.details?.increase)) || 0;
  const displayId = isSession ? data.identifier : (data.saleId || data.id);
  const responsibleName = (typeof data.responsible === 'string' && isNaN(data.responsible) ? data.responsible : null)
    || data.userName
    || data.sellerName
    || (credencials?.name ? `${credencials.name} ${credencials.lastName || ''}`.trim() : null)
    || (typeof data.userId === 'string' && isNaN(data.userId) ? data.userId : null)
    || '';
  const customerName = isSession
    ? data.responsible
    : (data.customerData?.name || options.customer?.name || (typeof data.customer === 'object' ? data.customer?.name : null) || data.customerFormatted || (typeof data.customer === 'string' && isNaN(data.customer) ? data.customer : 'Avulso'));
  const customerLastName = !isSession ? (data.customerData?.lastName || options.customer?.lastName || (typeof data.customer === 'object' ? data.customer?.lastName : '') || '') : '';
  const customerCpf = !isSession ? (data.customerData?.cpf || options.customer?.cpf || (typeof data.customer === 'object' ? data.customer?.cpf : '') || '') : '';
  const customerPhone = !isSession ? (data.customerData?.phone || options.customer?.phone || (typeof data.customer === 'object' ? data.customer?.phone : '') || '') : '';
  
  const numberOfPeople = options.numberOfPeople || 1;
  const valuePerPerson = total / numberOfPeople;
  
  const itemsSum = [...products, ...services].reduce((acc, it) => {
    const itemSub = it.subtotal !== undefined ? Number(it.subtotal) : (Number(it.price || it.value || 0) * Number(it.amount || 1));
    return acc + (isNaN(itemSub) ? 0 : itemSub);
  }, 0);
  const subtotal = itemsSum > 0 ? itemsSum : (Number(data.totalSum || data.details?.totalSum) || (total + discount - increase));

  // Inline styles
  const s = {
    page: {
      backgroundColor: '#fff',
      color: '#000',
      width: '100%',
      maxWidth: '210mm',
      margin: '0 auto',
      padding: '12mm 15mm',
      fontFamily: 'Arial, Helvetica, sans-serif',
      fontSize: '10pt',
      lineHeight: '1.3',
      boxSizing: 'border-box',
    },
    // Header
    headerRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      borderBottom: '2px solid #333',
      paddingBottom: '10px',
      marginBottom: '12px',
    },
    companyName: {
      fontSize: '16pt',
      fontWeight: 'bold',
      color: '#1a237e',
    },
    companyDetail: {
      fontSize: '9pt',
      color: '#666',
      margin: '2px 0',
    },
    docType: {
      fontSize: '13pt',
      fontWeight: 'bold',
      color: '#333',
      textAlign: 'right',
    },
    docMeta: {
      fontSize: '9pt',
      color: '#666',
      textAlign: 'right',
      margin: '2px 0',
    },
    // Sections
    sectionTitle: {
      fontWeight: 'bold',
      fontSize: '10pt',
      color: '#fff',
      backgroundColor: '#3f51b5',
      padding: '5px 10px',
      marginTop: '12px',
      marginBottom: '8px',
    },
    infoGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px 24px',
      padding: '4px 10px',
      marginBottom: '4px',
    },
    infoItem: {
      fontSize: '10pt',
    },
    infoLabel: {
      fontWeight: 'bold',
      color: '#333',
    },
    infoValue: {
      color: '#000',
    },
    // Table
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '10pt',
      marginBottom: '12px',
    },
    th: {
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      padding: '6px 8px',
      fontWeight: 'bold',
      fontSize: '9pt',
      textTransform: 'uppercase',
      color: '#333',
    },
    td: {
      border: '1px solid #ddd',
      padding: '5px 8px',
      fontSize: '9.5pt',
    },
    // Summary
    summaryBox: {
      width: '260px',
      marginLeft: 'auto',
      border: '1px solid #ccc',
      borderRadius: '4px',
      overflow: 'hidden',
    },
    summaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '5px 10px',
      fontSize: '9.5pt',
      borderBottom: '1px solid #eee',
    },
    summaryTotalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '7px 10px',
      fontSize: '11pt',
      fontWeight: 'bold',
      backgroundColor: '#f5f5f5',
      borderTop: '2px solid #333',
    },
    // Footer
    footer: {
      marginTop: '20px',
      paddingTop: '10px',
      textAlign: 'center',
      fontSize: '8pt',
      color: '#888',
      borderTop: '1px solid #ddd',
    },
  };

  const now = new Date();

  return (
    <div style={s.page}>
      {/* ===== HEADER ===== */}
      <div style={s.headerRow}>
        <div>
          <div style={s.companyName}>{credencials.companyData?.pseudonimo || 'Empresa'}</div>
          {credencials.companyData?.showCNPJ && credencials.companyData?.cnpj && (
            <div style={s.companyDetail}>CNPJ: {credencials.companyData.cnpj}</div>
          )}
        </div>
        <div>
          <div style={s.docType}>
            {isSession ? 'ORÇAMENTO' : 'RESUMO DA VENDA'}
          </div>
          <div style={s.docMeta}># {displayId}</div>
          <div style={s.docMeta}>
            {now.toLocaleDateString('pt-BR')} às {now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      </div>

      {/* ===== DADOS DO CLIENTE ===== */}
      <div style={s.sectionTitle}>
        DADOS DA VENDA
      </div>
      <div style={s.infoGrid}>
        <div style={s.infoItem}>
          <span style={s.infoLabel}>Cliente: </span>
          <span style={s.infoValue}>{customerName} {customerLastName}</span>
        </div>
        {responsibleName && (
          <div style={s.infoItem}>
            <span style={s.infoLabel}>Vendedor: </span>
            <span style={s.infoValue}>{responsibleName}</span>
          </div>
        )}
        {customerCpf && (
          <div style={s.infoItem}>
            <span style={s.infoLabel}>CPF/CNPJ: </span>
            <span style={s.infoValue}>{customerCpf}</span>
          </div>
        )}
        {customerPhone && (
          <div style={s.infoItem}>
            <span style={s.infoLabel}>Telefone: </span>
            <span style={s.infoValue}>{customerPhone}</span>
          </div>
        )}
      </div>

      {/* ===== ITENS ===== */}
      <div style={s.sectionTitle}>
        {isSession ? 'ITENS DO ORÇAMENTO' : 'ITENS DA VENDA'}
      </div>
      <table style={s.table}>
        <thead>
          <tr>
            <th style={{ ...s.th, textAlign: 'left', width: '45%' }}>Descrição</th>
            <th style={{ ...s.th, textAlign: 'center', width: '10%' }}>Qtd</th>
            <th style={{ ...s.th, textAlign: 'right', width: '15%' }}>Unitário</th>
            <th style={{ ...s.th, textAlign: 'right', width: '15%' }}>Desconto</th>
            <th style={{ ...s.th, textAlign: 'right', width: '15%' }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 && products.map((p, i) => {
            const itemSubtotal = p.subtotal !== undefined ? Number(p.subtotal) : (Number(p.price || p.value || 0) * Number(p.amount || 1));
            const itemDiscount = Number(p.discount) || 0;
            const itemTotal = p.total !== undefined ? Number(p.total) : (itemSubtotal - itemDiscount);

            return (
              <tr key={`p-${i}`}>
                <td style={s.td}>{p.item || p.name}</td>
                <td style={{ ...s.td, textAlign: 'center' }}>{p.amount}</td>
                <td style={{ ...s.td, textAlign: 'right' }}>{formattedCurrency(p.price)}</td>
                <td style={{ ...s.td, textAlign: 'right', color: itemDiscount > 0 ? '#16A34A' : '#666' }}>
                  {itemDiscount > 0 ? `-${formattedCurrency(itemDiscount)}` : '-'}
                </td>
                <td style={{ ...s.td, textAlign: 'right', fontWeight: 600 }}>{formattedCurrency(itemTotal)}</td>
              </tr>
            );
          })}
          {services.length > 0 && (
            <>
              {products.length > 0 && (
                <tr>
                  <td colSpan={5} style={{ ...s.td, border: 'none', padding: '2px 0' }}></td>
                </tr>
              )}
              {services.map((sv, i) => {
                const itemSubtotal = sv.subtotal !== undefined ? Number(sv.subtotal) : (Number(sv.price || sv.value || 0) * Number(sv.amount || 1));
                const itemDiscount = Number(sv.discount) || 0;
                const itemTotal = sv.total !== undefined ? Number(sv.total) : (itemSubtotal - itemDiscount);

                return (
                  <tr key={`s-${i}`}>
                    <td style={s.td}>{sv.item || sv.name}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{sv.amount}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{formattedCurrency(sv.price)}</td>
                    <td style={{ ...s.td, textAlign: 'right', color: itemDiscount > 0 ? '#16A34A' : '#666' }}>
                      {itemDiscount > 0 ? `-${formattedCurrency(itemDiscount)}` : '-'}
                    </td>
                    <td style={{ ...s.td, textAlign: 'right', fontWeight: 600 }}>{formattedCurrency(itemTotal)}</td>
                  </tr>
                );
              })}
            </>
          )}
        </tbody>
      </table>

      {/* ===== RESUMO FINANCEIRO ===== */}
      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: '200px' }}>
          {isSession && numberOfPeople > 1 && (
            <div style={{ padding: '12px', border: '2px solid #3f51b5', borderRadius: '6px', textAlign: 'center', marginBottom: '8px' }}>
              <div style={{ fontSize: '11pt', fontWeight: 'bold', marginBottom: '4px' }}>
                DIVISÃO ESTIMADA ({numberOfPeople} pessoas)
              </div>
              <div style={{ fontSize: '14pt', color: '#3f51b5', fontWeight: 'bold' }}>
                {formattedCurrency(valuePerPerson)} / pessoa
              </div>
              <div style={{ fontSize: '8pt', color: '#888', marginTop: '4px' }}>
                * Valor sujeito a alterações no fechamento.
              </div>
            </div>
          )}
          {!isSession && data.plots && Object.keys(data.plots).length > 0 && (
            <>
              <div style={s.sectionTitle}>PAGAMENTO</div>
              <table style={{ ...s.table, marginBottom: '8px' }}>
                <tbody>
                  {Object.entries(data.plots).map(([key, val]) => {
                    const isPaid = typeof val === 'string' && val.toLowerCase().includes('paga');
                    const amount = isPaid ? Number(val.split(' -')[0]) : Number(val);
                    return (
                      <tr key={key}>
                        <td style={{ padding: '4px 8px', border: 'none' }}>{key}ª Parcela</td>
                        <td style={{ padding: '4px 8px', border: 'none', textAlign: 'right' }}>
                          {formattedCurrency(amount)}
                          {isPaid && <span style={{ color: '#2e7d32', fontWeight: 'bold', marginLeft: '6px' }}>PAGA</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>

        {/* Right: Summary box */}
        <div style={s.summaryBox}>
          <div style={s.sectionTitle}>RESUMO DE VALORES</div>
          <div style={{ padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px' }}>
            <div style={s.summaryRow}>
              <span>Subtotal:</span>
              <span>{formattedCurrency(subtotal)}</span>
            </div>
            {discount > 0 && (
              <div style={{ ...s.summaryRow, color: '#16A34A' }}>
                <span>Desconto:</span>
                <span>- {formattedCurrency(discount)}</span>
              </div>
            )}
            {increase > 0 && (
              <div style={{ ...s.summaryRow, color: '#1565c0' }}>
                <span>Acréscimo:</span>
                <span>+ {formattedCurrency(increase)}</span>
              </div>
            )}
            <div style={s.totalRow}>
              <span>TOTAL:</span>
              <span>{formattedCurrency(total)}</span>
            </div>
            {!isSession && (
              <div style={{ ...s.summaryRow, color: '#666', marginTop: '2px' }}>
                <span>Recebido:</span>
                <span>{formattedCurrency(data.amountPaid)}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <div style={s.footer}>
        <div style={{ marginBottom: '4px' }}>
          {isSession
            ? 'Este documento é apenas um orçamento/conferência e não possui valor fiscal.'
            : 'Obrigado pela preferência!'}
        </div>
        <div>
          {credencials.companyData?.pseudonimo}
          {credencials.companyData?.showCNPJ && credencials.companyData?.cnpj ? ` • CNPJ: ${credencials.companyData.cnpj}` : ''}
        </div>
      </div>
    </div>
  );
};

